
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/[slug]",
      function () {
        return require("private-next-pages/events/[slug].jsx");
      }
    ]);
  